var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuturestepbonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H1",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.355 7.973L31 16.247l-7.355-8.274L26.25 4.5h9.5l2.605 3.473z",
    stroke: "#572DA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.25L27 8l-.75-3.5M31 16.25L35 8l.75-3.5M23.5 8h15",
    stroke: "#572DA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 8l4-3.5L35 8",
    stroke: "#572DA5",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#572DA5"
  })));
}
SvgFuturestepbonus.displayName = 'Futurestepbonus';
export default SvgFuturestepbonus;